import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDateStruct, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { IncidentAccidentCommentModel, IncidentAccidentModel } from '../../../models/incidentAccidentModel';
import { IncidentAccidentServiceService, ModuleService, SiteService } from '../../../services';
import { modalLarge } from '../../../shared/modules/dialogOptions';

@Component({
    selector: 'app-incident-accident-details-public',
    templateUrl: './incident-accident-details-public.component.html',
    styleUrls: ['./incident-accident-details-public.component.scss']
})
export class IncidentAccidentDetailsPublicComponent implements OnInit {

    showSpinner: false;
    model: IncidentAccidentModel = new IncidentAccidentModel();
    saving: boolean = false;
    module: any;
    moduleId: number = 30;
    sites: any = [];
    user: any
    skadetypes: any = [];
    skadetypesLoading: boolean = false;
    Comment: string = '';
    fmActionOptions: string = "";
    DateComment: NgbDateStruct;
    TimeComment: NgbTimeStruct;
    GeneratingReport: boolean = false;
    constructor(public location: Location,
        private modalService: NgbModal,
        private route: ActivatedRoute, private moduleService: ModuleService, private siteService: SiteService, private incidentAccidentSerice: IncidentAccidentServiceService) { }
    formType: string = "Incident";
    ngOnInit() {
        var now = new Date();

        this.user = JSON.parse(localStorage.getItem('currentUser'));
        this.model.Date = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        this.model.Time = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };
        this.DateComment = this.model.Date;
        this.TimeComment = this.model.Time;

        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                // const type = params['type'];

                // if(type == 0)
                // {
                //   this.formType = "Incident";
                // }
                // else if(type == 1)
                // {
                //   this.formType = "Accident";
                // }

                this.incidentAccidentSerice.Get(id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.model = response.Data;
                        if (this.model.AccidentType == 0) {
                            this.formType = "Incident";
                        }
                        else {
                            this.formType = "Accident";
                        }

                        this.loadSkadetypes();

                        var folder = "";
                        if (this.model.AccidentType == 0) {
                            folder = "Incident";
                        } else if (this.model.AccidentType == 1) {
                            folder = "Personskada";
                        } else if (this.model.AccidentType == 2) {
                            folder = "Fastighetsskada";
                        }

                        this.fmActionOptions = `&useSpecificSite=True&siteId=${this.model.SiteId}&useCustomRootFolder=True&customFolderName=${folder}_Data&rootFolderPrefix=${this.model.Id}`;

                    });

                // this.model.SiteId = id;
                var user = JSON.parse(localStorage.getItem('currentUser'));

                this.loadSites(user.accountId);

            }
        });

    }

    openFolderManager(settingsContent: string) {

        this.modalService.open(settingsContent, modalLarge);
    }

    generateReport() {
        alert('test');
    };

    saveComment() {

        this.saving = true;
        var commentModel = new IncidentAccidentCommentModel();
        commentModel.Comment = this.Comment;
        commentModel.DateModel = this.DateComment;
        commentModel.TimeModel = this.TimeComment;
        commentModel.IncidentAccidentId = this.model.Id;
        //commentModel.Date = Date.now();
        this.incidentAccidentSerice.AddComment(commentModel)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.saving = false;
                this.Comment = "";
                var now = new Date();
                this.DateComment = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
                this.TimeComment = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };
                this.ngOnInit();
                //this.location.back();
            });
    }

    saveChanges() {
        this.saving = true;

        this.incidentAccidentSerice.saveIncidentAccident(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.saving = false;

                //this.ngOnInit();
                this.location.back();
            });

    }

    closeIncident() {
        this.incidentAccidentSerice.toggleClose(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.saving = false;

                this.ngOnInit();
                // this.location.back();
            });
    };

    loadSites(accountId: number) {
        var user = JSON.parse(localStorage.getItem('currentUser'));

        this.moduleService.getModuleByTitle("Incident Accident")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((resp: any) => {

                this.module = resp.Data;

                this.siteService.getByAccountIdAndUserId(accountId, user.id, this.module.Id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.sites = response.Data;

                        if (this.model.SiteId == null || this.model.SiteId == 0) {

                            if (this.sites == undefined || this.sites.length == 0) {
                                return;
                            }

                            if (this.sites.filter(x => x.Id == this.model.SiteId).length <= 0) {

                                this.model.SiteId = this.sites[0].Id;

                            }
                        }

                    });
            });

    }

    loadSkadetypes() {

        if (this.model.AccidentType != undefined && this.model.AccidentType != 0) {
            this.skadetypesLoading = true;
            this.incidentAccidentSerice.GetSkadetypes(this.model.AccidentType, this.user.accountId)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.skadetypes = response.Data;
                    this.skadetypesLoading = false;
                });
        }

    }

    downloadPdf() {
        this.GeneratingReport = true;
        this.incidentAccidentSerice.DownloadReport(this.model.Id, this.user.accountId, this.formType == "Accident")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);
                this.GeneratingReport = false;
                // this.sending = false;
            });
    };
}



// WEBPACK FOOTER //
// ./src/app/components/incident-accident/public/incident-accident-details-public.component.ts